import { createContext, useContext } from 'react'
import { IconName } from '../atoms/Icon'
import { SectionColorKey } from '../molecules/AnalysisSidebar/AnalysisSidebar.types'

export interface AnalysisSectionTheme {
  icon?: IconName
  sectionColor?: SectionColorKey
}

const AnalysisSectionThemeContext = createContext<AnalysisSectionTheme>({})

export const AnalysisSectionThemeProvider = AnalysisSectionThemeContext.Provider

export const useAnalysisSectionTheme = () =>
  useContext(AnalysisSectionThemeContext)
